module.exports = __webpack_public_path__ + "static/media/whatsapp.93a88060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatsapp.png
// module id = 171
// module chunks = 0